import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Wrapper } from 'modules/layout/components';
import SettingsSidebar from '../../sidebar';
import { Alert, confirm } from 'modules/common/utils';
import APIManager from 'modules/common/apiManager';
import { Row, RowTitle, Box, BoxName, Divider } from '../../main/styles';
import { BarItems } from 'modules/layout/styles';
import { DataWrapperClass } from '../styles';
import { Modal } from 'react-bootstrap';
import { ModalFooter } from 'modules/common/styles/main';
import { ButtonCommonTheme } from 'modules/theme';
import { FiTrash2 } from 'react-icons/fi';
import { PerPage } from 'helpers/system-config';
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination
} from 'modules/common/components';

import {
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/common/styles/main';
import SIPAddEdit from './SIPAddEdit';

export class SIP extends Component {
  constructor(props) {
    super(props);

    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);

    this.mAPI = new APIManager();

    if (this.editData) {
      this.state = {
        sip: this.editData.sip,
        password: this.editData.password
      };
    } else {
      this.state = {
        sip: '',
        password: ''
      };
    }
    // this.handleModalShowHide = this.handleModalShowHide.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      showHide: false,
      shoowHideEdit: false
    };
  }

  updateSIPExtension(tSIPExtension) {
    debugger;
    let tData = {
      sip: tSIPExtension.sip,
      password: tSIPExtension.password
    };
    console.log(JSON.stringify(tData, null, 2));
    if (this.editData) {
      this.mAPI.sendPostAPI(
        `setting/sip/${tSIPExtension._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          this.resetAllData();
          Alert.success(`SIP Extension ${tData.sip} is Updated.`);
          this.handleModalShowHide();
        },
        (errorCode, data) => {
          console.log(`Error: `, errorCode);
          console.log(`Data`, data);
          Alert.error(`errorCode : ${data.message}`);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    }
  }

  saveData(e) {
    e.preventDefault();
    let tData = {
      sip: this.state.sip,
      password: this.state.password
    };
    console.log(JSON.stringify(tData, null, 2));
    if (this.editData) {
      this.mAPI.sendPostAPI(
        `setting/sip/${this.editData._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          this.resetAllData();
          Alert.success(`SIP Extension ${tData.sip} is Updated.`);
          this.handleModalShowHide();
        },
        (errorCode, data) => {
          console.log(`Error: `, errorCode);
          console.log(`Data`, data);
          Alert.error(`errorCode : ${data.message}`);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        'setting/sip',
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
        },
        (errorCode, data) => {
          console.log(`Error:`, errorCode);
          if (errorCode === 201) {
            this.getSIPExtensions();
            this.handleModalShowHide();
            this.resetAllData();
            Alert.success(`${data.message}`);
          } else {
            Alert.error(`${data.message}`);
          }
        }
      );
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      sip: '',
      password: ''
    });
  }

  handleModalShowHide() {
    this.setState({ showHide: !this.state.showHide });
  }

  handleEditModalShowHide() {
    this.setState({ shoowHideEdit: !this.state.shoowHideEdit });
  }

  componentDidMount() {
    this.getSIPExtensions();
  }

  remove(array, key, value) {
    const index = array.findIndex(obj => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  onChange() { }

  onSingleChange(e, company) { }

  getSIPExtensions(page = 1, perPage = '') {
    var that = this;
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/sip?limit=${perPage}&page_no=${page}`,
      data => {
        console.log(JSON.stringify(data, null, 2));
        if (data && data.list) {
          that.setState({ listData: data.list, total: data.count || 0 });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          Alert.error(`${error} : ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  onPaginationChange(page) {
    console.log('onPaginationChange', page);
    this.setState({ currentPage: page });
    this.getSIPExtensions(page);
  }
  onPerPageChooser(perPage) {
    console.log('onPerPageChooser', perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getSIPExtensions(1, perPage, this.state.search);
  }

  deleteSIPExtension(tSIPExtension) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/sip/${tSIPExtension._id}`,
      undefined,
      data => {
        console.log(JSON.stringify(data, null, 2));
        let tD = that.state.listData;
        tD = that.remove(tD, '_id', tSIPExtension._id);
        that.setState({ listData: tD });
        that.getSIPExtensions();
        Alert.success(`The ${tSIPExtension.sip} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data.message}`);
      },
      'private',
      {},
      'DELETE'
    );
  }

  renderActions(tSIPExtension) {
    return (
      <ActionButtons>
        {this.editSIPExtension(tSIPExtension)}
        <Tip text={`${'delete'}`} key={`${'delete'}`}>
          <Button
            btnStyle="link"
            onClick={e =>
              confirm().then(e => {
                this.deleteSIPExtension(tSIPExtension, e);
              })
            }
            style={{ verticalAlign: 'middle' }}
          // icon={<VscTrash />}
          >
            <FiTrash2 style={{ fontSize: '14px' }} />
          </Button>
        </Tip>
      </ActionButtons>
    );
  }

  editSIPExtension(tSIPExtension) {
    return <SIPAddEdit size="small" editData={tSIPExtension} />;
  }

  renderActionBar() {
    return (
      <div>
        <Button
          btnStyle="default"
          size="small"
          icon="add"
          onClick={() => this.handleModalShowHide()}
        >
          Add SIP Extension
        </Button>

        <Modal show={this.state.showHide} className="right">
          <Modal.Header closeButton onClick={() => this.handleModalShowHide()}>
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={e => this.saveData(e)}>
              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('SIP Extension', {
                    defaultValue: '',
                    autoFocus: true,
                    required: true,
                    id: 'name',
                    value: this.state.sip,
                    onChange: e => {
                      this.setState({ sip: e.target.value });
                    }
                  })}
                </FormColumn>
              </FormWrapper>

              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('Password', {
                    defaultValue: '',
                    autoFocus: true,
                    required: true,
                    value: this.state.password,
                    onChange: e => {
                      this.setState({ password: e.target.value });
                    },
                    id: 'password'
                  })}
                </FormColumn>
              </FormWrapper>
              <ModalFooter>

                <ButtonCommonTheme type='blueModalBtn' btnType='submit' modalBtnTitle='Save' btnStyle="default" icon="checked-1" />

                <ButtonCommonTheme type='greyModalBtn' modalBtnTitle='Cancel'
                  btnStyle="simple"
                  onClick={() => this.handleModalShowHide()}
                  icon="cancel-1" />
              </ModalFooter>
            </form>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.shoowHideEdit} className="right">
          <Modal.Header
            closeButton
            onClick={() => this.handleEditModalShowHide()}
          >
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={e => this.updateSIPExtension(e)}>
              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('SIP Extension', {
                    defaultValue: '',
                    autoFocus: true,
                    required: true,
                    id: 'name',
                    value: this.state.sip,
                    onChange: e => {
                      this.setState({ sip: e.target.value });
                    }
                  })}
                </FormColumn>
              </FormWrapper>

              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup('Password', {
                    defaultValue: '',
                    autoFocus: true,
                    required: true,
                    value: this.state.password,
                    onChange: e => {
                      this.setState({ password: e.target.value });
                    },
                    id: 'password'
                  })}
                </FormColumn>
              </FormWrapper>
              <ModalFooter>
                <ButtonCommonTheme type='blueModalBtn' btnType='submit' modalBtnTitle='Save' btnStyle="default" icon="checked-1" />
              </ModalFooter>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __('Settings'), link: '/settings' },
      { title: __('SIP'), link: '/settings/SIP' }
    ];

    const mainContent = (
      <DataWrapperClass>
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th>
                <FormControl
                  componentClass="checkbox"
                // onChange={this.onChange}
                />
              </th>
              <th style={{ textAlign: 'center' }}>{__('SIP')}</th>
              <th style={{ textAlign: 'center' }}>{__('Type')}</th>
              <th style={{ textAlign: 'center' }}>{__('Actions')}</th>
            </tr>
          </thead>
          <tbody id="SIPExtensions">
            {this.state.listData.map(tSIPExtension => (
              <tr>
                <td onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    onChange={e => this.onSingleChange(e, tSIPExtension)}
                  />
                </td>
                <td style={{ textAlign: 'center' }} className="text-primary">
                  {tSIPExtension.sip}
                </td>
                <td style={{ textAlign: 'center' }}>{tSIPExtension.type}</td>
                <td style={{ textAlign: 'center' }}>
                  {this.renderActions(tSIPExtension)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div>
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            actionBar={
              <Wrapper.ActionBar
                left={<ControlLabel>SIP</ControlLabel>}
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingsSidebar />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.props.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText=""
                  emptyImage="/images/emptySIP.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

SIP.contextTypes = {
  __: PropTypes.func
};

export default SIP;



// WEBPACK FOOTER //
// src/modules/screens/settings/SIP/components/SIP.js